import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { store } from "react-notifications-component";
import Tippy from "@tippyjs/react";
import 'tippy.js/dist/tippy.css';
import api from "../../services/api";
import GenericUpper from "../../components/generic-upper";
import Modal from "../../components/modal/modalGeneric";
import Button from "../../components/button/button_v2";
import InputV3 from "../../components/input/novo/input_v3";
import Interruptor from "../../components/interruptor";
import { Container } from "react-grid-system";
import { TaglineG, TaglineGSpan, TaglineP } from "../../styles/stylesTypography";
import { theme } from "../../styles/theme";
import maintainUtm from "../../services/maintainUtm";
import { isTotvs } from "../../services/globalFunctions";
import { getSendNfStatus, putSendNfStatus } from "../../services/sendNf";

import * as S from "./styles";
import { getFlag } from "../../assets/flags";
import { ufDisplayNames } from "./sharedData";
import iconDownloadWhite from "../../assets/icons/icon-download-white.png";
import iconDownloadBlack from "../../assets/icons/icon-download-black.png";
import iconWarningRed from "../../assets/icons/icon-warning-red.png";
import iconCheckWhite from "../../assets/icons/icon-check-white.svg";
import iconCheckBlack from "../../assets/icons/icon-check-black.svg";
import IconHelp from "../../assets/icons/help";

export const USER = "@userinfo";

const renderRichText = (text) => {
  if (!text) return text;
  return String(text)
    .split(/(<b>.*?<\/b>)/g)
    .map((part, index) => {
      const match = part.match(/^<b>(.*)<\/b>$/);
      return match ? <strong key={index}>{match[1]}</strong> : part;
    });
};

const normalizeSearchValue = (value) => String(value ?? "")
  .normalize("NFD")
  .replace(/\p{M}/gu, "")
  .toLowerCase()
  .trim();

const ExportarDefesas = ({ history }) => {
  const [availableScopes, setAvailableScopes] = useState([]);
  const [availableNfScopes, setAvailableNfScopes] = useState([]);
  const [loadingScopes, setLoadingScopes] = useState(true);
  const [pendenciasPorEstado, setPendenciasPorEstado] = useState({});
  const [homologacoes, setHomologacoes] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  // null = ainda não sabemos; o valor só vem do GET /send-nf/:id.
  const [naoVendeDefensivos, setNaoVendeDefensivos] = useState(null);
  const [loadingNaoVendeDefensivos, setLoadingNaoVendeDefensivos] = useState(true);
  const [savingNaoVendeDefensivos, setSavingNaoVendeDefensivos] = useState(false);
  const [reloadingPendencias, setReloadingPendencias] = useState(false);

  const [showModalBlock, setShowModalBlock] = useState(false);

  const labelMap = {
    NACIONAL: "TRT → CFTA",
    BA: "ART → ADAB",
    ES: "ART → IDAF",
    GO: "ART → SIDAGO",
    DF: "ART → SIAGRO DF",
    MT: "ART → SISDEV",
    COMPLEMENTAR: "ART → RECEITA COMPLEMENTAR",
    MG: "ART → SICCA",
    PR: "ART → SIAGRO",
    RS: "ART → SDA RS",
    SC: "ART → CIDASC",
    SP: "Contratos → CDA-SP",
  };

  const labelMapNf = {
    NACIONAL: "NF → CFTA",
    BA: "NF → ADAB",
    ES: "NF → IDAF",
    GO: "NF → SIDAGO",
    DF: "NF → SIAGRO DF",
    MT: "NF → SISDEV",
    COMPLEMENTAR: "NF → RECEITA COMPLEMENTAR",
    MG: "NF → SICCA",
    PR: "NF → SIAGRO",
    RS: "NF → SDA RS",
    SC: "NF → CIDASC",
    SP: "NF → CDA-SP",
  };

  const orgaoHeadingMap = {
    NACIONAL: "TRT → CFTA",
    BA: "ADAB",
    ES: "IDAF",
    GO: "SIDAGO",
    DF: "SIAGRO DF",
    MT: "SISDEV",
    COMPLEMENTAR: "SISDEV",
    MG: "SICCA",
    PR: "SIAGRO",
    RS: "SIG@",
    SC: "SIGEN+",
    SP: "Contratos → CDA-SP",
  };

  const descriptionMap = {
    NACIONAL: "Exporta seus <b>Termos de Responsabilidade Técnica</b> no formato exigido pelo CFTA (Conselho Federal dos Técnicos Agrícolas), válido em todo o território nacional.",
    BA: "Gera o relatório do receituário agronômico conforme a regra da ADAB (Agência de Defesa Agropecuária da Bahia).",
    ES: "Envio automático do receituário ao <b>e-IDAF</b> (Instituto de Defesa Agropecuária e Florestal) assim que emitido. <b>Requer</b> cadastrar seu usuário e senha do e-IDAF no AgroReceita.",
    GO: "Envio automático do receituário ao <b>SIDAGO</b> assim que emitido. Órgão: AGRODEFESA.",
    DF: "Envio automático do receituário ao <b>SIAGRO DF</b> assim que emitido. Órgão: SEAGRI-DF.",
    MT: "As <b>receitas comuns</b> são enviadas automaticamente ao <b>SISDEV</b> (Sistema de Defesa Vegetal) do INDEA-MT assim que emitidas.",
    COMPLEMENTAR: "Geramos o relatório para você enviar os dados ao SISDEV.",
    MG: "Gera o relatório de <b>comercialização de defensivos</b> conforme o SICCA (Sistema de Controle de Comércio de Agrotóxicos). Órgão: IMA.",
    PR: "Gera o relatório do receituário agronômico conforme a regra do <b>SIAGRO</b> (Sistema de Monitoramento do Comércio e Uso de Agrotóxicos). Órgão: ADAPAR.",
    RS: "Gera o relatório do receituário agronômico conforme a regra do <b>SIG@</b> (Sistema Integrado de Gestão de Agrotóxicos). Órgão: SEAPDR-RS.",
    SC: "Envio automático do receituário ao <b>SIGEN+</b> (Sistema de Gestão da Defesa Agropecuária Catarinense) assim que emitido. <b>Requer</b> cadastrar seu usuário e senha do SIGEN+ no AgroReceita. Órgão: CIDASC.",
    SP: "Gera o arquivo com os <b>Contratos de Prestação de Serviço</b> de acordo com as regras da CDA-SP (Coordenadoria de Defesa Agropecuária do Estado de São Paulo).",
  };

  const descriptionMapNf = {
    NACIONAL: "Exporta suas notas fiscais no formato exigido pelo CFTA (Conselho Federal dos Técnicos Agrícolas), válido em todo o território nacional.",
    BA: "Gera o relatório de notas fiscais conforme a regra da ADAB (Agência de Defesa Agropecuária da Bahia).",
    ES: "Envio automático das notas fiscais ao e-IDAF (Instituto de Defesa Agropecuária e Florestal) assim que emitidas. Requer cadastrar seu usuário e senha do e-IDAF no AgroReceita.",
    GO: "Envio automático das notas fiscais ao SIDAGO assim que emitidas. Órgão: AGRODEFESA.",
    DF: "Envio automático das notas fiscais ao SIAGRO DF assim que emitidas. Órgão: SEAGRI-DF.",
    MT: "As notas fiscais são enviadas automaticamente ao SISDEV (Sistema de Defesa Vegetal) do INDEA-MT assim que emitidas.",
    COMPLEMENTAR: "Geramos o relatório de notas fiscais para você enviar os dados ao SISDEV.",
    MG: "Gera o relatório de notas fiscais conforme o SICCA (Sistema de Controle de Comércio de Agrotóxicos). Órgão: IMA.",
    PR: "Gera o relatório de notas fiscais conforme a regra do SIAGRO (Sistema de Monitoramento do Comércio e Uso de Agrotóxicos). Órgão: ADAPAR.",
    RS: "Gera o relatório de notas fiscais conforme a regra do SIG@ (Sistema Integrado de Gestão de Agrotóxicos). Órgão: SEAPDR-RS.",
    SC: "Envio automático das notas fiscais ao SIGEN+ (Sistema de Gestão da Defesa Agropecuária Catarinense) assim que emitidas. Requer cadastrar seu usuário e senha do SIGEN+ no AgroReceita. Órgão: CIDASC.",
    SP: "Gera o arquivo com os Contratos de Prestação de Serviço de acordo com as regras da CDA-SP (Coordenadoria de Defesa Agropecuária do Estado de São Paulo).",
  };

  const badgeTypeByUF = {
    NACIONAL: "relatorio",
    BA: "relatorio",
    ES: "automatico",
    GO: "automatico",
    DF: "automatico",
    MT: "automatico",
    COMPLEMENTAR: "relatorio",
    MG: "relatorio",
    PR: "relatorio",
    RS: "relatorio",
    SC: "automatico",
    SP: "relatorio",
  };

  const badgeLabelByType = {
    relatorio: "RELATÓRIO",
    envio: "ENVIO DE DADOS",
    automatico: "ENVIO AUTOMÁTICO",
  };

  // Status do toggle "Não vendo defensivos" (agro_subsidiaries.envio_nf) da
  // filial do usuário logado. A coluna guarda o envio de NF, então a leitura é
  // invertida: envio_nf = 0 liga o toggle (não vende) e 1 desliga (vende, que
  // é o padrão da coluna).
  const getSendNf = async () => {
    const nf = await getSendNfStatus();

    // O toggle só assume um estado depois que a rota responde.
    if (nf === 0 || nf === 1) {
      setNaoVendeDefensivos(nf === 0);
    }

    setLoadingNaoVendeDefensivos(false);
  };

  useEffect(() => {
    getSendNf();
  }, []);

  // Atualiza na hora e desfaz se o PUT falhar, para o toggle nunca ficar
  // mostrando um estado que não foi gravado.
  const handleToggleNaoVendeDefensivos = async (next) => {
    if (savingNaoVendeDefensivos || loadingNaoVendeDefensivos) return;
    if (naoVendeDefensivos === null) return;

    const previous = naoVendeDefensivos;

    setNaoVendeDefensivos(next);
    setSavingNaoVendeDefensivos(true);
    // Os cards saem do ar enquanto /relatorios/homologacoes recalcula as
    // pendências com o novo valor, para não exibir dado desatualizado.
    setReloadingPendencias(true);

    try {
      const nf = await putSendNfStatus(next ? 0 : 1);

      if (nf === 0 || nf === 1) {
        setNaoVendeDefensivos(nf === 0);
      }

      // Os cards vêm da rota de homologações, que passa a esconder (ou
      // voltar a mostrar) a pendência de NF conforme o valor gravado.
      await fetchHomologacoes();
    } catch (error) {
      setNaoVendeDefensivos(previous);

      store.addNotification({
        title: "Erro!",
        message:
          error?.response?.data?.errors ||
          "Não foi possível salvar a opção - Tente novamente, se o erro persistir acione o suporte.",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });
    } finally {
      setSavingNaoVendeDefensivos(false);
      setReloadingPendencias(false);
    }
  };

  const badgeButtonLabelByType = {
    relatorio: "BAIXAR RELATÓRIO",
    envio: "GERAR ARQUIVO DE ENVIO",
    automatico: "VER RECEITAS ENVIADAS",
  };

  const historicoOptionByUF = {
    PR: 1,
    SC: 2,
    MT: 3,
    GO: 4,
    DF: 4,
    RS: 5,
    ES: 6,
    BA: 7,
    MG: 8,
  };

  const hasAnyTrue = (obj) => {
    if (!obj || typeof obj !== "object") return false;
    return Object.values(obj).some((v) => v === true);
  };

  const getArtsByEstado = async ({ estado, limit = 100, offset = 0, search = "", filters = {} }) => {
    const payload = { search, estado, filters };
    const response = await api.post(`/art/pesquisa?limit=${limit}&offset=${offset}`, payload);
    const data = response?.data?.data;
    const arts = data?.arts || data || [];
    return Array.isArray(arts) ? arts : [];
  };

  const hasSPArts = async () => {
    try {
      const arts = await getArtsByEstado({ estado: "SP", limit: 100 });
      return Array.isArray(arts) && arts.length > 0;
    } catch (e) {
      return false;
    }
  };

  const hasTRTArts = async () => {
    try {
      const arts = await getArtsByEstado({ estado: "NACIONAL", limit: 1 });
      return Array.isArray(arts) && arts.length > 0;
    } catch (e) {
      return false;
    }
  };

  const sortScopes = (scopes) => {
    return scopes.sort((a, b) => {
      if (a === "NACIONAL") return -1;
      if (b === "NACIONAL") return 1;
      if (a === "MT" && b === "COMPLEMENTAR") return -1;
      if (a === "COMPLEMENTAR" && b === "MT") return 1;
      return a.localeCompare(b);
    });
  };

  // A rota já devolve a pendência de NF zerada para quem não vende
  // defensivos, então o card só precisa reler depois que o toggle muda.
  const fetchHomologacoes = async () => {
    try {
      const responseHomolog = await api.get("/relatorios/homologacoes");
      const dataHomolog = responseHomolog?.data?.data || [];
      const pendenciasMap = {};
      dataHomolog.forEach((row) => {
        if (row?.estado && (row?.pendencia_nf || row?.pendencia_envio)) {
          // Tipado por UF: nf (relatório de NF) e envio (relatório de
          // receitas/ART) nunca devem acionar o card um do outro.
          pendenciasMap[row.estado] = {
            nf: row.pendencia_nf || null,
            envio: row.pendencia_envio || null,
          };
        }
      });
      setPendenciasPorEstado(pendenciasMap);
      setHomologacoes(dataHomolog);
    } catch (e) {
      // Falha silenciosa: mantém as pendências e os cards de "consulte a defesa" ocultos
    }
  };

  const hydrateScopes = async () => {
    setLoadingScopes(true);
    let scopes = [];
    let nfScopes = [];

    const user = JSON.parse(localStorage.getItem(USER));
    const subsidiaryId = user?.agro_subsidiary_id;

    // 1. Busca da API (Histórico ART/Receitas: PR, SC, MT, GO, RS, ES, BA, MG, etc.)
    try {
      if (subsidiaryId) {
        const response = await api.get(`/relatorios/defesas/receitas/${subsidiaryId}`);
        const data = response?.data?.data || [];
        scopes = [...data];
      }
    } catch (e) {
      // Falha silenciosa ou array vazio
    }

    // 2. Busca da API (Histórico NF: PR, SC, MT, GO, RS, ES, BA, MG, etc.)
    try {
      if (subsidiaryId) {
        const responseNf = await api.get(`/relatorios/defesas/nf/${subsidiaryId}`);
        const dataNf = responseNf?.data?.data || [];
        nfScopes = [...dataNf];
      }
    } catch (e) {
      // Falha silenciosa ou array vazio
    }

    // 3. Lógica antiga para SP
    const sp = await hasSPArts();
    if (sp && !scopes.includes("SP")) {
      scopes.push("SP");
    }

    // 4. Lógica antiga para NACIONAL
    const trt = await hasTRTArts();
    if (trt && !scopes.includes("NACIONAL")) {
      scopes.push("NACIONAL");
    }

    // 5. Homologações por estado (pendências reais + estados só "consulte a defesa")
    await fetchHomologacoes();

    setAvailableScopes(sortScopes(scopes));
    setAvailableNfScopes(sortScopes(nfScopes));
    setLoadingScopes(false);
  };

  useEffect(() => {
    hydrateScopes();
  }, []);

  const openPlanos = () => {
    setShowModalBlock(false);
    history.push({
      pathname: "/planos",
      search: maintainUtm(),
    });
  };

  const openHistoricoModal = (uf, { siagroLink = 1 } = {}) => {
    if (["GO", "DF", "ES", "MT", "SC", "COMPLEMENTAR"].includes(uf)) {
        history.push({
          pathname: `/exportar-defesas/${uf}`,
          search: maintainUtm(),
      });
      return;
    }

    const opt = historicoOptionByUF[uf];
    if (!opt) return;

    let user = JSON.parse(localStorage.getItem(USER));

    if (user?.contrato?.agro_plan_config?.is_teste === 1) {
      setShowModalBlock(true);
    } else {
      const siagroQuery = uf === "PR" && siagroLink === 2 ? "siagroLink=2" : "";
      const search = siagroQuery
        ? `?${siagroQuery}${maintainUtm(undefined, true)}`
        : maintainUtm();
      history.push({
        pathname: `/exportar-defesas/relatorio/${uf}`,
        search,
      });
    }
  };

  const openHistoricoModalNf = (uf, { siagroLink = 1 } = {}) => {
    if (["GO", "DF", "ES", "MT", "SC", "COMPLEMENTAR"].includes(uf)) {
      history.push({
        pathname: `/exportar-defesas/nf/${uf}`,
        search: maintainUtm(),
      });
      return;
    }

    const opt = historicoOptionByUF[uf];
    if (!opt) return;

    let user = JSON.parse(localStorage.getItem(USER));

    if (user?.contrato?.agro_plan_config?.is_teste === 1) {
      setShowModalBlock(true);
    } else {
      const siagroQuery = uf === "PR" && siagroLink === 2 ? "siagroLink=2" : "";
      const search = siagroQuery
        ? `?${siagroQuery}${maintainUtm(undefined, true)}`
        : maintainUtm();
      history.push({
        pathname: `/exportar-defesas/relatorio/nf/${uf}`,
        search,
      });
    }
  };

  const renderScopeButton = (uf, type = "art") => {
    const isNf = type === "nf";
    const handleHistoricoClick = isNf
      ? (opts) => openHistoricoModalNf(uf, opts)
      : (opts) => openHistoricoModal(uf, opts);
    const onClick =
      uf === "SP"
        ? () => history.push({ pathname: "/exportar-defesas/sp", search: maintainUtm() })
        : uf === "NACIONAL"
          ? () => history.push({ pathname: "/exportar-defesas/nacional", search: maintainUtm() })
          : () => handleHistoricoClick();
    const keyPrefix = `${type}-${uf}`;
    const description = (isNf ? descriptionMapNf : descriptionMap)[uf] || "";
    const flagSrc = getFlag(uf, ufDisplayNames[uf]);
    const badgeType = badgeTypeByUF[uf] || "relatorio";
    const buttonLabel = badgeButtonLabelByType[badgeType];

    // O card de ART/relatório (isNf=false) sempre leva a uma tabela de
    // receitas que mostra envio e NF juntos (details.js para ES/GO/MT/SC/DF,
    // details-relatorio.js para BA/MG/PR/RS) — então precisa acender
    // pendência de NF também, não só de envio, senão o usuário nunca vê o
    // alerta mesmo tendo NF pendente (era restrito a badgeType==="automatico",
    // mas BA por exemplo é "relatorio" e nunca tem um card nf separado).
    const pendenciaEntry = pendenciasPorEstado[uf] || {};
    const pendenciaText = isNf
      ? pendenciaEntry.nf || null
      : [pendenciaEntry.nf, pendenciaEntry.envio].filter(Boolean).join(". ") || null;
    const hasPendencia = Boolean(pendenciaText);

    return (
      <S.Card key={keyPrefix}>
        <S.CardHeader>
          <S.CardHeaderInfo>
            {flagSrc ? (
              <S.CardFlag src={flagSrc} alt={`Bandeira - ${ufDisplayNames[uf] || uf}`} />
            ) : (
              <S.CardFlagFallback>{uf === "NACIONAL" ? "BR" : uf}</S.CardFlagFallback>
            )}
            <TaglineGSpan>{ufDisplayNames[uf] || uf}</TaglineGSpan>
          </S.CardHeaderInfo>
          
          <S.CardBadge variant={badgeType}>
            {badgeLabelByType[badgeType]}
          </S.CardBadge>
        </S.CardHeader>

        {orgaoHeadingMap[uf] && <S.CardOrgao>{orgaoHeadingMap[uf]}</S.CardOrgao>}
        {description && <S.CardDescription>{renderRichText(description)}</S.CardDescription>}

        <S.CardActions>
          {hasPendencia && (
            <>
              <S.PendingBadge>
                <img src={iconWarningRed} alt="" />
                {pendenciaText}
              </S.PendingBadge>
              <div style={{ alignSelf: "flex-start" }}>
                <Button
                  width="auto"
                  height="39px"
                  value="RESOLVER PENDÊNCIAS"
                  red={true}
                  outline={false}
                  disabled={false}
                  onClick={onClick}
                  loading={false}
                />
              </div>
            </>
          )}
          {hasPendencia ? (
            <div style={{ alignSelf: "flex-start" }}>
              <Button
                width="auto"
                height="39px"
                value={buttonLabel}
                icon={badgeType === "automatico" ? iconCheckBlack : iconDownloadBlack}
                outline={true}
                color="#000"
                disabled={false}
                onClick={onClick}
                loading={false}
              />
            </div>
          ) : (
            <Button
              width="100%"
              height="39px"
              value={buttonLabel}
              icon={badgeType === "automatico" ? iconCheckWhite : iconDownloadWhite}
              outline={false}
              disabled={false}
              onClick={onClick}
              loading={false}
            />
          )}
          {!isNf && isTotvs() && uf === "PR" && (
            <Button
              width="100%"
              height="39px"
              value={badgeButtonLabelByType.relatorio}
              icon={iconDownloadWhite}
              outline={false}
              disabled={false}
              onClick={() => openHistoricoModal(uf, { siagroLink: 2 })}
              loading={false}
            />
          )}
        </S.CardActions>
      </S.Card>
    );
  };

  const renderMtCard = (type, hasComum, hasComplementar) => {
    const isNf = type === "nf";
    const flagSrc = getFlag("MT", ufDisplayNames.MT);
    const outerDescription = (isNf ? descriptionMapNf : descriptionMap).MT;
    const complementarDescription = (isNf ? descriptionMapNf : descriptionMap).COMPLEMENTAR;
    const comumClick = isNf ? () => openHistoricoModalNf("MT") : () => openHistoricoModal("MT");
    const complementarClick = isNf ? () => openHistoricoModalNf("COMPLEMENTAR") : () => openHistoricoModal("COMPLEMENTAR");

    // MT também é "automático" com tabela única (mesma lógica de renderScopeButton).
    const mtPendenciaEntry = pendenciasPorEstado.MT || {};
    const pendenciaText = isNf
      ? mtPendenciaEntry.nf || null
      : [mtPendenciaEntry.nf, mtPendenciaEntry.envio].filter(Boolean).join(". ") || null;
    const hasPendencia = Boolean(pendenciaText);

    return (
      <S.Card key={`mt-merged-${type}`}>
        <S.CardHeader>
          <S.CardHeaderInfo>
            {flagSrc ? (
              <S.CardFlag src={flagSrc} alt="Bandeira - Mato Grosso" />
            ) : (
              <S.CardFlagFallback>MT</S.CardFlagFallback>
            )}
            <S.CardTitle>Mato Grosso</S.CardTitle>
          </S.CardHeaderInfo>
        </S.CardHeader>

        <S.CardOrgao>SISDEV</S.CardOrgao>
        <S.CardDescription>{renderRichText(outerDescription)}</S.CardDescription>

        {hasComum && (
          <S.MtSubCard>
            <S.MtSubHeader>
              <S.MtSubTitle>{isNf ? "NF comum" : "Receita comum"}</S.MtSubTitle>
              <S.CardBadge variant="automatico">{badgeLabelByType.automatico}</S.CardBadge>
            </S.MtSubHeader>
            <S.CardDescription>Enviada automaticamente ao SISDEV na emissão.</S.CardDescription>
            <S.CardActions>
              {hasPendencia && (
                <>
                  <S.PendingBadge>
                    <img src={iconWarningRed} alt="" />
                    {pendenciaText}
                  </S.PendingBadge>
                  <div style={{ alignSelf: "flex-start" }}>
                    <Button
                      width="auto"
                      height="39px"
                      value="RESOLVER PENDÊNCIAS"
                      red={true}
                      outline={false}
                      disabled={false}
                      onClick={comumClick}
                      loading={false}
                    />
                  </div>
                </>
              )}
              {hasPendencia ? (
                <div style={{ alignSelf: "flex-start" }}>
                  <Button
                    width="auto"
                    height="39px"
                    value={badgeButtonLabelByType.automatico}
                    icon={iconCheckBlack}
                    outline={true}
                    color="#000"
                    disabled={false}
                    onClick={comumClick}
                    loading={false}
                  />
                </div>
              ) : (
                <Button
                  width="100%"
                  height="39px"
                  value={badgeButtonLabelByType.automatico}
                  icon={iconCheckWhite}
                  outline={false}
                  disabled={false}
                  onClick={comumClick}
                  loading={false}
                />
              )}
            </S.CardActions>
          </S.MtSubCard>
        )}

        {hasComplementar && (
          <S.MtSubCard>
            <S.MtSubHeader>
              <S.MtSubTitle>{isNf ? "NF Complementar" : "Receita Complementar"}</S.MtSubTitle>
              <S.CardBadge variant="relatorio">{badgeLabelByType.relatorio}</S.CardBadge>
            </S.MtSubHeader>
            <S.CardDescription>{renderRichText(complementarDescription)}</S.CardDescription>
            <S.CardActions>
              <Button
                width="100%"
                height="39px"
                value={badgeButtonLabelByType.relatorio}
                icon={iconDownloadBlack}
                outline={true}
                color="#000"
                disabled={false}
                onClick={complementarClick}
                loading={false}
              />
            </S.CardActions>
          </S.MtSubCard>
        )}
      </S.Card>
    );
  };

  const renderConsulteDefesaCard = (row) => {
    const uf = row.estado;
    const flagSrc = getFlag(uf, ufDisplayNames[uf]);
    const description = `Consulte a ${row.defesa} para saber como enviar os dados dos seus receituários.`;

    return (
      <S.Card key={`consulte-${uf}`}>
        <S.CardHeader>
          <S.CardHeaderInfo>
            {flagSrc ? (
              <S.CardFlag src={flagSrc} alt={`Bandeira - ${ufDisplayNames[uf] || uf}`} />
            ) : (
              <S.CardFlagFallback>{uf}</S.CardFlagFallback>
            )}
            <TaglineGSpan>{ufDisplayNames[uf] || uf}</TaglineGSpan>
          </S.CardHeaderInfo>

          <S.CardBadge variant="consulte">CONSULTE A DEFESA</S.CardBadge>
        </S.CardHeader>

        {row.defesa && <S.CardOrgao>{row.defesa}</S.CardOrgao>}
        <S.CardDescription>{description}</S.CardDescription>

        {row.link && (
          <S.CardActions>
            <Button
              width="100%"
              height="39px"
              value="VER CONTATO DO ÓRGÃO"
              outline={true}
              color="#000"
              disabled={false}
              onClick={() => window.open(row.link, "_blank", "noopener,noreferrer")}
              loading={false}
            />
          </S.CardActions>
        )}
      </S.Card>
    );
  };

  return (
    <>
      <GenericUpper align="center" title="Exportar para as Defesas Agropecuárias" subtitle="Selecione a UF/escopo para gerar seus relatórios" />
      <Container>
        <div style={{ maxWidth: '820px', margin: '24px 0 0', textAlign: 'left' }}>
          <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={800}>
            O AgroReceita envia os dados das suas receitas agronômicas às Defesas Agropecuárias conforme as regras de cada estado.
          </TaglineP>
        </div>

        {!loadingScopes && (
          <S.SearchRow>
            <S.SearchField>
              <InputV3
                id="search-exportar-defesas"
                type="search"
                radius={true}
                searchLeft={true}
                floatingLabel="Buscar por estado ou órgão (ex: Bahia, SISDEV...)"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </S.SearchField>

            <S.ToggleRow
              onClick={() => handleToggleNaoVendeDefensivos(!naoVendeDefensivos)}
            >
              <Interruptor
                value={naoVendeDefensivos === true}
                onChange={handleToggleNaoVendeDefensivos}
                disabled={
                  savingNaoVendeDefensivos ||
                  loadingNaoVendeDefensivos ||
                  naoVendeDefensivos === null
                }
              />
              <TaglineG color={theme.colors.gray.Cinza_2}>
                Não vendo defensivos
              </TaglineG>

              <Tippy
                content="Ao marcar essa opção, você não verá mais alertas de pendências relacionadas a Nota Fiscal."
                animation="fade"
                delay={[0, 100]}
                arrow
                theme="light"
                placement="top"
                appendTo={() => document.body}
                zIndex={99999}
                // No mobile não há hover: o toque abre a tooltip, e o
                // stopPropagation impede que esse mesmo toque alterne o toggle.
                trigger="mouseenter focus click"
                maxWidth={280}
              >
                <S.ToggleHelpIcon
                  type="button"
                  aria-label="Sobre a opção Não vendo defensivos"
                  onClick={(e) => e.stopPropagation()}
                >
                  <IconHelp fill={theme.colors.blue.Azul_link} />
                </S.ToggleHelpIcon>
              </Tippy>
            </S.ToggleRow>
          </S.SearchRow>
        )}

        {loadingScopes || reloadingPendencias ? (
         <S.LoadingContainer>
            <S.Loading />
          </S.LoadingContainer>
        ) : (() => {
          const getTitle = (uf, type) => {
            const isNf = type === "nf";
            const map = isNf ? labelMapNf : labelMap;
            const label = map[uf] || uf;
            const displayUf = uf === "NACIONAL" ? "Nacional" : uf;
            return uf === "COMPLEMENTAR"
              ? isNf ? "MT: NF → RECEITA COMPLEMENTAR" : "MT: RECEITA COMPLEMENTAR"
              : `${displayUf}: ${label}`;
          };
          const normalizedSearch = normalizeSearchValue(searchTerm);

          const buildDynamicItems = (scopes, type) => {
            const hasComum = scopes.indexOf("MT") !== -1;
            const hasComplementar = scopes.indexOf("COMPLEMENTAR") !== -1;
            const rest = scopes
              .filter((uf) => uf !== "MT" && uf !== "COMPLEMENTAR")
              .map((uf) => ({ kind: "dynamic", uf, type }));
            const mtItem = (hasComum || hasComplementar)
              ? [{ kind: "mt-merged", uf: "MT", type, hasComum, hasComplementar }]
              : [];
            return [...rest, ...mtItem];
          };

          // Sempre 1 card por UF: quando a mesma UF aparece nos dois escopos
          // (art e nf), o segundo (nf) é descartado - o card "art" já é o
          // card oficial daquela UF na listagem (a distinção nf só existe
          // pra quem navega direto pro relatório de NF, ex: GO/DF).
          const seenUfsForDedup = new Set();
          const dynamicItems = [
            ...buildDynamicItems(availableScopes, "art"),
            ...buildDynamicItems(availableNfScopes, "nf"),
          ].filter((item) => {
            if (seenUfsForDedup.has(item.uf)) return false;
            seenUfsForDedup.add(item.uf);
            return true;
          }).filter((item) => {
            if (!normalizedSearch) return true;
            if (item.kind === "mt-merged") {
              const haystack = normalizeSearchValue(`Mato Grosso MT SISDEV ${getTitle("MT", item.type)} ${getTitle("COMPLEMENTAR", item.type)}`);
              return haystack.includes(normalizedSearch);
            }
            const haystack = normalizeSearchValue(`${ufDisplayNames[item.uf] || item.uf} ${item.uf} ${getTitle(item.uf, item.type)}`);
            return haystack.includes(normalizedSearch);
          });

          // Estados sem integração (só "consulte a defesa") retornados pela API de homologações,
          // que ainda não têm um card curado acima — exibidos uma única vez, sem separar ART/NF.
          const consulteDefesaItems = homologacoes
            .filter((row) => row?.tipo_homolog === "CONSULTE_A_DEFESA" && !(row.estado in badgeTypeByUF))
            .filter((row) => {
              if (!normalizedSearch) return true;
              const haystack = normalizeSearchValue(`${ufDisplayNames[row.estado] || row.estado} ${row.estado} ${row.defesa} CONSULTE A DEFESA`);
              return haystack.includes(normalizedSearch);
            })
            .map((row) => ({ kind: "consulte", uf: row.estado, row }));

          const allItems = [...dynamicItems, ...consulteDefesaItems].sort((a, b) => {
            if (a.uf === "NACIONAL" && b.uf !== "NACIONAL") return -1;
            if (b.uf === "NACIONAL" && a.uf !== "NACIONAL") return 1;

            return (ufDisplayNames[a.uf] || a.uf).localeCompare(ufDisplayNames[b.uf] || b.uf);
          });

          return allItems.length === 0 ? null : (
            <S.CardsGrid>
              {allItems.map((item) => {
                if (item.kind === "dynamic") return renderScopeButton(item.uf, item.type);
                if (item.kind === "consulte") return renderConsulteDefesaCard(item.row);
                return renderMtCard(item.type, item.hasComum, item.hasComplementar);
              })}
            </S.CardsGrid>
          );
        })()}
      </Container>

      {showModalBlock && (
        <Modal show={showModalBlock} onHide={() => setShowModalBlock(false)}>
          <h4
            style={{
              textAlign: "center",
            }}
          >
            Essa é uma função exclusiva para clientes AgroReceita
          </h4>

          <p
            style={{
              textAlign: "center",
              marginTop: "20px",
            }}
          >
            Para não comprometer o controle de suas receitas agronômicas durante o
            período de teste esta função é bloqueada.
          </p>

          <p
            style={{
              textAlign: "center",
              marginTop: "20px",
            }}
          >
            Assine o AgroReceita para desbloquear esta função!
          </p>

          <div
            className="button-finish"
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              marginTop: "40px",
            }}
          >
            <Button
              width="296px"
              height="39px"
              value="VER PLANOS"
              outline={false}
              disabled={false}
              onClick={() => openPlanos(false)}
              loading={false}
            />
          </div>
        </Modal>
      )}

    </>
  );
};

export default withRouter(ExportarDefesas);
